<template>
    <div :class="cardClass">
        <div class="DonutCard__header-bar">
            <div class="DonutCard__header">
                <slot name="header">
                    {{ header }}
                    <RPTooltip
                        :tooltip="headerTooltip"
                    />
                </slot>
            </div>
            <div class="DonutCard__action">
                <slot name="action"></slot>
            </div>
        </div>
        <RPDonutChart
            v-if="show"
            :chart-data="chartData"
            :show-legend="showLegend"
            :legend-position="legendPosition"
            :show-total="showTotal"
            :total-label="totalLabel"
            :height="200"
        />
    </div>
</template>
<script>
import RPTooltip from 'components/Basic/Elements/RPTooltip.vue';
import RPDonutChart from './RPDonutChart.vue';
import stat from 'status';
import statusBuilder from 'status/statusBuilder';

export default {
    name: 'RPDonutCard',
    components: {
        RPTooltip,
        RPDonutChart
    },
    props: {
        header: {
            type: String,
            required: true
        },
        headerTooltip: {
            type: String,
            default: ''
        },
        chartData: {
            type: Array,
            required: true
        },
        showLegend: {
            type: Boolean,
            default: true
        },
        legendPosition: {
            type: String,
            default: 'bottom',
            validator: val => ['bottom', 'left', 'right'].indexOf(val) !== -1,
        },
        showTotal: {
            type: Boolean,
            default: true
        },
        totalLabel: {
            type: String,
            default: ''
        },
        status: {
            type: String,
            default: stat.STANDBY,
        }
    },
    data(){
        return {
            show: true,
        };
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        cardClass(){
            return statusBuilder('DonutCard', this.status);
        },
    },
    watch: {
        isLoading(newStat, oldStat){
            if(newStat && !oldStat){
                this.show = false;
            } else{
                setTimeout(() => {
                    this.show = true;
                }, 1);
            }
        }
    },
};
</script>
<style lang="scss">
    .DonutCard {
        background: $white;
        min-width: 18rem;
        position: relative;
        border-radius: 4px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        padding: 1rem;
        background: $white;
        display: grid;
        grid-template-rows: min-content max-content;
        row-gap: 1rem;

        @include loading(100%, 100%);

        &__header-bar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
        }
        &__header {
            display: flex;
            align-items: center;
            color: $text-dark;
            font-weight: 600;
            gap: 0.25rem;
        }
    }
</style>
